import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "hotspot-content" }

import ModalHotspot from "Vue/components/hotspotComponents/ModalHotspot.vue";
import {HotspotPlacement} from "Interfaces/Interfaces";

export default /*#__PURE__*/_defineComponent({
  __name: 'HotspotContent',
  props: {
	hotspotPlacements: {
		type: Array as () => HotspotPlacement[],
		default: []
	},
	activeHotspotIndex: {
		type: Number,
		default: 0
	},
	backgroundImage: {
		type: String,
		default: ''
	}
},
  emits: ['updateActiveHotspotIndex'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const updateActiveHotspotIndex = (indexValue) => {
	emit('updateActiveHotspotIndex', indexValue);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.hotspotPlacements?.length)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.hotspotPlacements, (placement, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: placement.Title
          }, [
            (placement?.SelectHotspot?.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (__props.activeHotspotIndex === index)
                    ? (_openBlock(), _createBlock(ModalHotspot, {
                        key: 0,
                        activeHotspotIndex: __props.activeHotspotIndex,
                        index: index,
                        placementsLength: __props.hotspotPlacements.length,
                        placement: placement,
                        hotspotItem: placement?.SelectHotspot[0],
                        onUpdateActiveHotspotIndex: updateActiveHotspotIndex
                      }, null, 8 /* PROPS */, ["activeHotspotIndex", "index", "placementsLength", "placement", "hotspotItem"]))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        }), 128 /* KEYED_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})